class @App.Clubs.ClubsIndexView
  constructor: ->
    @bindElements()

  bindElements: ->
    loadSlick()
    mobileTabs()
    BetterModals.showModal($('#modalRenewNotice')) if $('#modalRenewNotice').length

  loadSlick = ->
    $(document).ready ->
      $('.find-passion-carousel').slick {
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: false
      }

      $('.js-heroslider').slick {
        dots: true,
        autoplay: true,
        arrows: false,
        slide: '.heroslider__slide'
      }
      return

  mobileTabs = ->
    $(document).ready ->
      mobileTabsAddContent($('.active a[data-toggle="tab"]'))
      return

    $('a[data-toggle="tab"]').on 'click', (e) ->
      $tab = $(this)
      if $tab.parent('.teded-tabs__item').hasClass('active')
        e.preventDefault()

        window.setTimeout (->
          $('.tab-pane').removeClass 'active'
          $tab.parent('.teded-tabs__item').removeClass 'active'
          $('body').trigger('click')
          return
        ), 10

    $('a[data-toggle="tab"]').on 'show', (e) ->
      mobileTabsAddContent($(e.target))
      return

  mobileTabsAddContent = ($tablink) ->
    if $tablink.length < 0
      return false

    id = $tablink.attr('href')

    if ($tablink.siblings('.teded-tabs__pane--nested').length < 1)
      $paneContent =
        $('<div />').addClass('teded-tabs__pane--nested').html($(id).html())
      $paneContent.insertAfter($tablink)

    return

$(document).on 'turbo:load', ->
  new App.Clubs.ClubsIndexView() if $('.clubsIndexView').length
